import { render, staticRenderFns } from "./FixTimeAndQuota.vue?vue&type=template&id=79823d66"
import script from "./FixTimeAndQuota.vue?vue&type=script&lang=js"
export * from "./FixTimeAndQuota.vue?vue&type=script&lang=js"
import style0 from "./FixTimeAndQuota.vue?vue&type=style&index=0&id=79823d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports